<div class="modal-content">

<div class="modal-body p-4">
    <p class="mb-45">{{"INSCRIPTIONS.WaitingList.Subtitle" | translate}}</p>
    <form [formGroup]="inscripcioForm()">
        <div class="row g-45">
            <!-- Nom -->
            <div class="col-md-6 col-12">
                <p-floatLabel>
                    <input
                            pInputText
                            id="nom"
                            type="text"
                            class="w-100"
                            formControlName="nom"
                    />
                    <label for="nom">{{ 'Name' | translate}} *</label>
                </p-floatLabel>
            </div>

            <!-- Cognom -->
            <div class="col-md-6 col-12">
                <p-floatLabel>
                    <input
                            pInputText
                            id="cognom"
                            type="text"
                            class="w-100"
                            formControlName="cognom"
                    />
                    <label for="cognom">{{ 'Surnames' | translate }} *</label>
                </p-floatLabel>
            </div>

            <!-- Email -->
            <div class="col-md-6 col-12">
                <p-floatLabel>
                    <input
                            pInputText
                            id="email"
                            type="email"
                            class="w-100"
                            formControlName="email"
                    />
                    <label for="email">Email *</label>
                </p-floatLabel>
            </div>

            <!-- Teléfono -->
            <div class="col-md-6 col-12">


                <p-floatLabel  class="p-float-label-active">
                    <app-custom-field-phone
                            name="phone"
                            formControlName="telefon"/>
                    <label for="telefon">{{ "Phone" | translate}} *</label>
                </p-floatLabel>
            </div>
            <div class="col-md-6 col-12" *ngIf="this.inscription()?.groups?.length">
                <p-floatLabel>
                    <p-dropdown
                            id="grup"
                            class="w-100"
                            [options]="groupsWithWaitingList()"
                            optionLabel="name"
                            formControlName="grup"
                            appendTo="body"
                            placeholder="{{'WAITINGLIST.selectGroup' | translate}}"
                    ></p-dropdown>
                    <label for="grup">{{'WAITINGLIST.group' | translate}} *</label>
                </p-floatLabel>
            </div>
            <!-- Nº persones -->
            <div class="col-md-6 col-12">
                <p-floatLabel>
                    <input
                            pInputText
                            id="persones"
                            type="number"
                            class="w-100"
                            min="1"
                            [max]="maxTiquets() ?? null"
                            formControlName="persones"
                    />
                    <label for="persones">{{"WAITINGLIST.npersons" | translate}} *
                        <span *ngIf="this.maxTiquets() != 0">(max: {{maxTiquets()}})</span></label>
                </p-floatLabel>
            </div>



        </div>

    </form>

    <app-button-loading class="mt-4 fw-500 rounded text-white"
                        [style]="'--corp-color:' +color+ ';'"
                        [text]="'WAITINGLIST.ButtonWaitingList' | translate"
                        [icon]="'fa fa-save'"
                        [customClass]="'rounded corp-color text-white'"
                        [disabled]="inscripcioForm().invalid"
                        [actionAsync]="onSubmit"
                        >
    </app-button-loading>
</div>

</div>
